import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';

export default function MobileApps() {
    const navigate = useNavigate();
    const containerRef = useRef();
    const paragraphRef = useRef(null);
    const listRef = useRef([]);

    const listItems = [
        'Assist you with getting your application listed on the Apple and Google stores',
        'Build iOS and Android applications for you',
        'Build the backend for you',
        'Test your application(s)',
    ];

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(paragraphRef.current, {
                x: -50,
                opacity: 0,
                duration: 0.5,
                ease: 'power2.out',
                delay: 0.3,
            });

            gsap.from(listRef.current, {
                x: -50,
                opacity: 0,
                duration: 0.5,
                ease: 'power2.out',
                stagger: 0.2,
                delay: 0.6,
            });
        }, containerRef);

        return () => ctx.revert(); // Clean up on unmount
    }, []);

    return (
        <div className="space-y-4" ref={containerRef}>
            <button
                onClick={() => navigate(-1)}
                className="text-sm text-blue-600 hover:underline"
            >
                ← Back to Services
            </button>

            <section className="p-6 border rounded-lg bg-gray-50 dark:bg-gray-800">
                <h2 className="text-2xl font-semibold mb-2">Mobile App Development</h2>

                <div>
                    <p ref={paragraphRef} className="p-6">
                        We create modern, responsive, and accessible mobile applications that help your business stand out in the digital economy.
                    </p>

                    <ul className="list-disc pl-6 space-y-2">
                        {listItems.map((item, index) => (
                            <li
                                key={index}
                                ref={(el) => (listRef.current[index] = el)}
                            >
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </div>
    );
}
